import React from 'react';
import { BatchFilters } from '../../../../app/models/Batch';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
  filter: BatchFilters;
  setFilter: (filter: BatchFilters) => void;
  onSearch: () => void;
};

type FilterKey =
  | 'id'
  | 'batch_category'
  | 'center'
  | 'warehouse'
  | 'project'
  | 'product'
  | 'quality'
  | 'availability_status';

const BatchFilter = ({ filter, setFilter, onSearch }: Props) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const key = name as FilterKey;
    const next: Partial<BatchFilters> = { ...filter, page: 1 };
    if (key === 'id') {
      next.id = value === '' ? undefined : parseInt(value, 10) || undefined;
    } else {
      (next as Record<string, unknown>)[key] = value;
    }
    setFilter(next as BatchFilters);
  };

  const doSearch = (e?: React.FormEvent) => {
    e?.preventDefault?.();
    onSearch();
  };

  return (
    <form onSubmit={doSearch}>
      <div className="row g-2 align-items-end">
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="id">
            Id Lote
          </label>
          <input
            type="text"
            id="id"
            name="id"
            className="form-control form-control-sm"
            placeholder="Ej: 14"
            value={filter.id != null ? String(filter.id) : ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="batch_category">
            Tipo de Lote
          </label>
          <select
            id="batch_category"
            name="batch_category"
            className="form-control form-control-sm"
            value={filter.batch_category ?? ''}
            onChange={handleChange}
          >
            <option value="">Todos</option>
            <option value="COMMERCIAL">Comercial</option>
            <option value="SELECTION">Selección</option>
            <option value="COLLECTION">Recolección</option>
          </select>
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="center">
            Centro
          </label>
          <input
            type="text"
            id="center"
            name="center"
            className="form-control form-control-sm"
            placeholder="Ej: HACIENDA 1"
            value={filter.center ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="warehouse">
            Almacén
          </label>
          <input
            type="text"
            id="warehouse"
            name="warehouse"
            className="form-control form-control-sm"
            placeholder="Ej: Camara de Frio"
            value={filter.warehouse ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="project">
            Proyecto
          </label>
          <input
            type="text"
            id="project"
            name="project"
            className="form-control form-control-sm"
            placeholder="Ej: Proyecto 1"
            value={filter.project ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="product">
            Producto
          </label>
          <input
            type="text"
            id="product"
            name="product"
            className="form-control form-control-sm"
            placeholder="Nombre producto"
            value={filter.product ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="quality">
            Calidad
          </label>
          <input
            type="text"
            id="quality"
            name="quality"
            className="form-control form-control-sm"
            placeholder="Ej: Corona, Standard"
            value={filter.quality ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="availability_status">
            Estado
          </label>
          <select
            id="availability_status"
            name="availability_status"
            className="form-control form-control-sm"
            value={filter.availability_status ?? ''}
            onChange={handleChange}
          >
            <option value="">Todas</option>
            <option value="FREE">Libre disponibilidad</option>
            <option value="COLLECTED">Acopiado</option>
          </select>
        </div>
        <div className="col-md-auto">
          <ButtonSearchFilter callbackSearch={doSearch} />
        </div>
      </div>
    </form>
  );
};

export default BatchFilter;
